var _desc, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconZoomoutHover(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon_zoomout_hover") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon_zoomout_hover",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L32,0 L32,29 C32,30.6568542 30.6568542,32 29,32 L3,32 C1.34314575,32 2.02906125e-16,30.6568542 0,29 L0,0 L0,0 Z",
    id: "Rectangle-729",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.6170046,19.770449 C21.1276651,20.2811429 21.1276651,21.1066122 20.6170046,21.6173061 C20.3623274,21.872 20.0279818,22 19.6936363,22 C19.3592908,22 19.0249453,21.872 18.7702681,21.6173061 L11.3820159,14.2298776 C10.8726614,13.7191837 10.8726614,12.8924082 11.3820159,12.3830204 C11.8926764,11.8723265 12.7193979,11.8723265 13.2287524,12.3830204 L20.6170046,19.770449 Z",
    id: "Path-Copy-2",
    fill: "#5697B7",
    transform: "translate(16.000000, 17.000000) rotate(-45.000000) translate(-16.000000, -17.000000) "
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0.5,
    y1: 0.5,
    x2: 31.5,
    y2: 0.5,
    id: "Line-7",
    stroke: "#E9E9E9",
    strokeLinecap: "square"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconZoomoutHover);
export default __webpack_public_path__ + "static/media/icon_zoomout_hover.df05a624d50358578c8317e4b95fbb03.svg";
export { ForwardRef as ReactComponent };